var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useCallback, useMemo } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGetListProfessionalSolutionMySolution } from '../../../../../actions/ProfessionalMySolutionActions';
import { wrapDispatch } from '../../../../../helpers/action';
import { isCanUseProfessionalProffitMart } from '../../../../../helpers/auth';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { useDidMount, usePromiseDoingCallback, useUnmountRef, } from '../../../../../helpers/use/useHook';
import { CurrentProcessLoader } from '../../../../Ui/Loading';
import ProfessionalMyPageTopMySolutionItem from './MySolutionItem';
const ProfessionalMyPageTopMySolution = (props) => {
    const { profile } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const useProffitMart = isCanUseProfessionalProffitMart(profile);
    const [page, changePage] = useState(1);
    const { list, solutionTotal } = useSelector((state) => state.professionalMySolution);
    const rows = list[page] || [];
    const pageCount = useMemo(() => Math.ceil(solutionTotal / 8), [solutionTotal]);
    /**
     * ソリューション事例の読み込み
     * @type {(function(*=): Promise<void>)|*}
     */
    const rawLoadData = useCallback((setPage = null) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiGetListProfessionalSolutionMySolution(setPage || page));
    }), [page, dispatch]);
    const [loadData, isLoading] = usePromiseDoingCallback(rawLoadData, unmountRef);
    /**
     * ページングのイベント
     * @type {(function({selected: *}): Promise<void>)|*}
     */
    const onPageChange = useCallback(({ selected }) => __awaiter(void 0, void 0, void 0, function* () {
        const currentPage = selected + 1;
        yield loadData(currentPage);
        if (!unmountRef.current) {
            changePage(currentPage);
        }
    }), [loadData, changePage, unmountRef]);
    useDidMount(() => {
        loadData();
    });
    return (_jsxs(_Fragment, { children: [useProffitMart && (_jsx("div", Object.assign({ className: 'align-center mt-24 mb50' }, { children: _jsx(Link, Object.assign({ className: 'btn btn-default wide large', to: '/mypage/solutions/add' }, { children: "\u65B0\u3057\u3044\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3092\u767B\u9332\u3059\u308B" })) }))), _jsx("h3", Object.assign({ className: 'project-title dblue' }, { children: _jsx("span", { children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B" }) })), isLoading && _jsx(CurrentProcessLoader, {}), !isLoading && rows.length === 0 && (_jsx("p", Object.assign({ className: 'align-center' }, { children: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093" }))), !isLoading &&
                rows.length > 0 &&
                rows.map((item) => (_jsx(ProfessionalMyPageTopMySolutionItem, { item: item, profile: profile }, item.solution.id))), _jsx("div", Object.assign({ className: 'pagination-menu' }, { children: _jsx(ReactPaginate, { marginPagesDisplayed: 3, nextLabel: null, onPageChange: onPageChange, pageCount: pageCount, previousLabel: null }) }))] }));
};
ProfessionalMyPageTopMySolution.propTypes = {
    profile: propShape().isRequired,
};
export default ProfessionalMyPageTopMySolution;
